import React from "react";

function GreenCheckIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.7656 1.02734C2.57722 1.02734 0.793945 2.81061 0.793945 4.99899C0.793945 7.18737 2.57722 8.97064 4.7656 8.97064C6.95397 8.97064 8.73724 7.18737 8.73724 4.99899C8.73724 2.81061 6.95397 1.02734 4.7656 1.02734ZM6.66404 4.08551L4.41212 6.33744C4.35651 6.39304 4.28105 6.42482 4.20162 6.42482C4.12219 6.42482 4.04673 6.39304 3.99112 6.33744L2.86715 5.21346C2.75197 5.09828 2.75197 4.90765 2.86715 4.79247C2.98232 4.67729 3.17296 4.67729 3.28814 4.79247L4.20162 5.70595L6.24305 3.66452C6.35823 3.54934 6.54887 3.54934 6.66404 3.66452C6.77922 3.7797 6.77922 3.96636 6.66404 4.08551Z"
        fill="#3EBF8F"
      />
    </svg>
  );
}

export default GreenCheckIcon;
